import PropTypes from 'prop-types';
import cn from "../../../utils/cn";
import Icon from "../../Display/Icon/Icon";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ResourcesHeader(_ref) {
  let {
    onSelectedProgramsClick,
    selectedProgramsAmount = 0,
    showAddedResourcesBtn = false
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "resources-header",
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex gap-4 items-center mb-4 justify-between",
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex items-center",
        children: /*#__PURE__*/_jsxs("h1", {
          className: "flex items-center",
          "data-testid": "resourcesHeaderText",
          children: [/*#__PURE__*/_jsx(Icon, {
            id: "resources-header-magnifying-glass-icon",
            className: "w-8 h-8 ml-3 mr-2",
            icon: "LogoShield",
            color: "#182A44"
          }), "Browse Resources"]
        })
      }), showAddedResourcesBtn && /*#__PURE__*/_jsxs("button", {
        type: "button",
        className: "bg-dark-blue text-white rounded-md p-3 relative flex gap-x-2 items-center",
        "data-testid": "addedResources",
        name: "addedResources",
        onClick: onSelectedProgramsClick(),
        children: [/*#__PURE__*/_jsx("span", {
          className: cn('number-circle inline-flex items-center justify-center leading-8 h-6 w-6 rounded-full text-center border-2 border-solid whitespace-no-wrap', selectedProgramsAmount > 0 ? 'border-grass-green' : 'border-white'),
          children: /*#__PURE__*/_jsx("span", {
            className: "count-text inline-block text-base text-white w-full",
            children: selectedProgramsAmount
          })
        }), /*#__PURE__*/_jsx("span", {
          className: "text-white",
          children: "Added Resources"
        })]
      })]
    })
  });
}
ResourcesHeader.propTypes = {
  selectedProgramsAmount: PropTypes.number,
  onSelectedProgramsClick: PropTypes.func.isRequired,
  showAddedResourcesBtn: PropTypes.bool
};
export default ResourcesHeader;
//# sourceMappingURL=ResourcesHeader.js.map